import { render, staticRenderFns } from "./Legal_success.vue?vue&type=template&id=6931012f&scoped=true"
import script from "./Legal_success.vue?vue&type=script&lang=js"
export * from "./Legal_success.vue?vue&type=script&lang=js"
import style0 from "./Legal_success.vue?vue&type=style&index=0&id=6931012f&prod&scoped=true&lang=less"
import style1 from "./Legal_success.vue?vue&type=style&index=1&id=6931012f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6931012f",
  null
  
)

export default component.exports